import styled from '@emotion/styled';
import { hideVisually } from 'polished';

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  column-gap: 0.5rem;
  cursor: pointer;
  user-select: none;
  vertical-align: bottom;
`;

type BoxProps = {
  $isChecked?: boolean;
};

export const Box = styled.span<BoxProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.1875rem;
  border: 1px solid
    ${({ theme, $isChecked }) =>
      $isChecked ? theme.colors.brand.green120 : theme.colors.neutral.grey100};
  border-radius: ${({ theme }) => theme.radius.xs};
  width: 1.25rem;
  height: 1.25rem;
  fill: ${({ theme, $isChecked }) =>
    $isChecked ? theme.colors.brand.green120 : 'inherit'};
  background-color: ${({ theme }) => theme.colors.neutral.white100};

  @media (hover: hover) {
    &:hover {
      border-color: ${({ theme, $isChecked }) =>
        $isChecked ? '' : theme.colors.neutral.grey140};
    }
  }
`;

// screen reader only
export const Input = styled.input`
  ${hideVisually()};

  &:focus-visible + ${Box} {
    border-radius: ${({ theme }) => theme.radius.xs};
    outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
    outline-offset: 0.25rem;
  }
`;
